import React from 'react';
import { StarIcon } from '@heroicons/react/20/solid';
import YouTubeVideoEmbed from './YouTubeVideoEmbed';

const MaltaSocialProof = ({ testimonials, stats }) => {
  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Stats Section */}
        {stats && (
          <div className="text-center mb-16">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              {stats.title}
            </h2>
            <p className="mt-4 text-lg text-gray-600">
              {stats.subtitle}
            </p>
            
            {/* Trust Badges */}
            {stats.trustBadges && (
              <div className="mt-8 flex flex-wrap justify-center gap-4">
                {stats.trustBadges.map((badge, index) => (
                  <span
                    key={index}
                    className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-advisor-100 text-advisor-800"
                  >
                    {badge}
                  </span>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Video Testimonial */}
        <div className="mb-16">
          <div className="bg-advisor-900 rounded-2xl p-8 text-center">
            <h3 className="text-2xl font-bold text-white mb-4">
              Hear from Our Customers
            </h3>
            <p className="text-advisor-100 mb-8">
              See how Chris transformed his accounting practice with Buddy
            </p>
            <div className="max-w-4xl mx-auto">
              <YouTubeVideoEmbed
                videoId="mM_Xj-1Rp4k"
                title="Chris Testimonial - Buddy Payroll"
                description="Hear how Chris transformed his accounting practice with Buddy"
                trackingEvent="testimonial_video"
                className="rounded-lg overflow-hidden"
              />
            </div>
            <div className="mt-6">
              <p className="text-lg text-white font-medium">
                "Buddy has revolutionized how we handle payroll for our clients"
              </p>
              <p className="text-advisor-200 mt-2">
                - Chris, Senior Accountant
              </p>
            </div>
          </div>
        </div>

        {/* Written Testimonials */}
        {testimonials && testimonials.length > 0 && (
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <StarIcon
                        key={i}
                        className="h-5 w-5 text-yellow-400"
                        aria-hidden="true"
                      />
                    ))}
                  </div>
                  {testimonial.verified && (
                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      ✓ Verified Customer
                    </span>
                  )}
                </div>
                <blockquote className="text-gray-900 mb-4">
                  "{testimonial.quote}"
                </blockquote>
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    {testimonial.avatar && (
                      <img
                        className="h-10 w-10 rounded-full"
                        src={testimonial.avatar}
                        alt={testimonial.name}
                      />
                    )}
                    <div className={testimonial.avatar ? "ml-4" : ""}>
                      <div className="text-sm font-medium text-gray-900">
                        {testimonial.name}
                      </div>
                      <div className="text-sm text-gray-500">
                        {testimonial.role}
                      </div>
                    </div>
                  </div>
                  {testimonial.result && (
                    <div className="text-right">
                      <div className="text-sm font-semibold text-advisor-900">
                        {testimonial.result}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Fallback content if no testimonials provided */}
        {(!testimonials || testimonials.length === 0) && (
          <div className="text-center">
            <div className="bg-gray-50 rounded-lg p-8">
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Social Proof Placeholder
              </h3>
              <p className="text-gray-600">
                TODO: Add client testimonials and company logos
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MaltaSocialProof;
